import React, { useRef, useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { getWidgetResize, pxToPercents, scaleDirs, updateWithPercents, updateWithPx, valueFromString, } from "../helpers";
import { useServices } from "../hooks/useServices";
import { Rnd } from "react-rnd";
import { FastButtons } from "../Components/FastButtons";
export const LayoutItem = ({ layoutItemsLength, isSelected, children, layoutItem, screenWidth, screenHeight, scale, isLocked, widgets, setAnimationsModalOpened, showAnimations, }) => {
    var _a;
    const { layoutService } = useServices();
    const itemRef = useRef(null);
    const [layoutItemWidthBeforeResize, setLayoutItemWidthBeforeResize] = useState();
    const [rndScale, setRndScale] = useState((_a = layoutItem.scale) !== null && _a !== void 0 ? _a : 1);
    const [rndLocked, setRndLocked] = useState(false);
    const widget = widgets.find((widget) => widget.name === layoutItem.widgetName);
    const widgetResize = getWidgetResize({
        isSelected,
        isLocked,
        resize: widget === null || widget === void 0 ? void 0 : widget.resize,
    });
    const rndSize = {
        width: valueFromString(layoutItem.width, screenWidth, 1, 0.25 * screenWidth),
        height: valueFromString(layoutItem.height, screenHeight, 1, 0.25 * screenHeight),
    };
    const rndPosition = {
        x: valueFromString(layoutItem.x, screenWidth, 1),
        y: valueFromString(layoutItem.y, screenHeight, 1),
    };
    useEffect(() => {
        var _a;
        setRndScale((_a = layoutItem.scale) !== null && _a !== void 0 ? _a : 1);
    }, [layoutItem.scale]);
    return (React.createElement(Rnd, { key: `layout-item-rnd-${layoutItem.id}`, disableDragging: !isSelected || isLocked || showAnimations, position: rndPosition, size: rndSize, lockAspectRatio: rndLocked, style: {
            outline: isSelected && !showAnimations
                ? `${2 / scale}px solid  var(--chakra-colors-orange-400)`
                : "none",
            zIndex: isSelected ? 10000 : layoutItem.z,
        }, cancel: ".rnd-cancel", resizeGrid: [1, 1], dragGrid: [1, 1], onDragStop: (e, d) => {
            const { x, y } = d;
            if (valueFromString(layoutItem.x, screenWidth, 1) === x &&
                valueFromString(layoutItem.y, screenHeight, 1) === y)
                return;
            if (layoutItem.unit === "%") {
                layoutService.updateLayoutItem({
                    ...layoutItem,
                    x: pxToPercents(x.toString(), screenWidth),
                    y: pxToPercents(y.toString(), screenHeight),
                });
            }
            if (layoutItem.unit === "px") {
                layoutService.updateLayoutItem({
                    ...layoutItem,
                    x: `${Math.round(x)}px`,
                    y: `${Math.round(y)}px`,
                });
            }
        }, scale: scale, onResizeStart: (_e, dir, ref) => {
            if (scaleDirs.includes(dir)) {
                setRndLocked(true);
            }
            setLayoutItemWidthBeforeResize(ref.offsetWidth);
        }, onResize: (e, dir, ref, delta) => {
            var _a;
            if (!scaleDirs.includes(dir))
                return;
            const previousUnscaledWidth = layoutItemWidthBeforeResize / ((_a = layoutItem.scale) !== null && _a !== void 0 ? _a : 1);
            const newScale = ref.offsetWidth / previousUnscaledWidth;
            setRndScale(newScale);
        }, onResizeStop: (e, direction, ref, delta, position) => {
            setRndLocked(false);
            if (layoutItem.unit === "px") {
                updateWithPx({
                    direction,
                    layoutItem,
                    layoutService,
                    position,
                    ref,
                    rndScale,
                });
                return;
            }
            updateWithPercents({
                direction,
                layoutItem,
                layoutService,
                position,
                ref,
                rndScale,
                screenHeight,
                screenWidth,
            });
        }, enableResizing: widgetResize, onClick: () => {
            if (isSelected)
                return;
            if (showAnimations)
                return;
            layoutService.selectLayoutItem(layoutItem.id);
        }, bounds: "#studio-preview" },
        React.createElement(Box, { transform: `scale(${rndScale})`, transformOrigin: "top left", width: `${100 / rndScale}%`, height: `${100 / rndScale}%`, ref: itemRef }, children),
        React.createElement(FastButtons, { isLocked: isLocked, isSelected: isSelected, layoutItem: layoutItem, layoutItemsLength: layoutItemsLength, scale: scale, screenHeight: screenHeight, setAnimationsModalOpened: setAnimationsModalOpened, showAnimations: showAnimations, widget: widget })));
};
